export const ADMIN_EMAIL = "babotesto@gmail.com";

export const isAdminEmail = (email?: string | null): boolean =>
  email === ADMIN_EMAIL;
